<!--
 * @Author: 赵健
 * @Date: 2021-01-21 11:56:45
 * @LastEditTime: 2021-01-23 15:53:43
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \trunk\src\views\merchantCenter\equityManage\info.vue
-->
<template>
  <div v-loading="loading">
    <um-bread-crumb />
    <el-card shadow="never">
      <div
        slot="header"
        class="card-header"
      >
        <span>基础信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <span class="um-label">所属板块/分类：</span>
          <span class="um-value">{{ baseInfo.sectionName +'-'+ baseInfo.categoryName }}</span>
        </el-col>
        <el-col :span="12">
          <span class="um-label">商家：</span>
          <span class="um-value">{{ baseInfo.merchantName }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="12">
          <span class="um-label">权益名称：</span>
          <span class="um-value">{{ baseInfo.equityName }}</span>
        </el-col>
        <el-col :span="12">
          <span class="um-label">权益描述：</span>
          <span class="um-value">{{ baseInfo.equityDescription }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="24">
          <span class="um-label">权益封面图：</span>
          <el-image
            v-for="(item,index) in baseInfo.equityDesignNoList"
            :key="index"
            style="width: 100px; height: 100px; margin-left:10px"
            :src="item"
            :preview-src-list="baseInfo.equityDesignNoList"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="8">
          <span class="um-label">是否需要预约：</span>
          <span class="um-value">{{ baseInfo.equityNeedAppointment==0?'是':'否' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="um-label">权益价值：</span>
          <span class="um-value">{{ baseInfo.equityValue||0 +'元' }}</span>
        </el-col>
        <el-col :span="8">
          <span class="um-label">权益总数量：</span>
          <span class="um-value">{{ baseInfo.equitySumNumber }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="12">
          <span class="um-label">权益时限：</span>
          <span class="um-value">{{ baseInfo.equityEffectiveStartTime +' - '+ baseInfo.equityEffectiveEndTime }}</span>
        </el-col>
        <el-col :span="12">
          <span class="um-label">权益使用时间段：</span>
          <span class="um-value">{{ baseInfo.equityUseStartTime +' - '+ baseInfo.equityUseEndTime }}</span>
        </el-col>
      </el-row>
    </el-card>
    <el-card shadow="never">
      <div
        slot="header"
        class="card-header"
      >
        <span>详细说明</span>
      </div>
      <tinymce :height="300" :readonly="true" :url="baseInfo.equityRemark" />
    </el-card>
    <el-card v-if="putOninfo&&Object.keys(putOninfo).length!=0" shadow="never">
      <div
        slot="header"
        class="card-header"
      >
        <span>上架信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <span class="um-label">操作人：</span>
          <span class="um-value">{{ putOninfo.createUserName }}</span>
        </el-col>
        <el-col :span="12">
          <span class="um-label">操作时间：</span>
          <span class="um-value">{{ putOninfo.createTime }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="24">
          <span class="um-label">上架说明：</span>
          <span class="um-value">{{ putOninfo.putOnRemark }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="24">
          <span class="um-label">附件：</span>
          <um-upload v-model="putOninfo.putOnDesignNoList" :disabled="true" />
        </el-col>
      </el-row>
    </el-card>
    <el-card v-if="equityReviewRecordVo&&Object.keys(equityReviewRecordVo).length!=0" shadow="never">
      <div
        slot="header"
        class="card-header"
      >
        <span>审核信息</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="12">
          <span class="um-label">审核人：</span>
          <span class="um-value">{{ equityReviewRecordVo.createUserName }}</span>
        </el-col>
        <el-col :span="12">
          <span class="um-label">审核时间：</span>
          <span class="um-value">{{ equityReviewRecordVo.createTime }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="12">
          <span class="um-label">审核结果：</span>
          <span class="um-value">{{ equityReviewRecordVo.reviewStatusCodeName }}</span>
        </el-col>
        <el-col :span="12">
          <span class="um-label">审核意见：</span>
          <span class="um-value">{{ equityReviewRecordVo.reviewRemark }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="margin-t-20">
        <el-col :span="24">
          <span class="um-label">附件：</span>
          <um-upload v-model="equityReviewRecordVo.reviewDesignNoList" :disabled="true" />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { merchantEquityDetail } from '@/api/merchantCenter'
import Tinymce from '@/components/Tinymce'
export default {
  name: 'MerchantEquityManageInfo',
  components: {
    Tinymce
  },
  data() {
    return {
      equityId: null,
      loading: false,
      baseInfo: {},
      putOninfo: {}, // 上架信息
      equityReviewRecordVo: {}// 审核信息
    }
  },
  created() {
    this.equityId = this.$route.query.equityId
    if (!this.equityId) {
      this.$router.go(-1)
    }
    this.getInfo()
  },
  methods: {
    async getInfo() {
      try {
        this.loading = true
        const res = await merchantEquityDetail({ equityId: this.equityId })
        this.baseInfo = res.data.equityManagementRecordVo
        this.putOninfo = res.data.putOninfo
        this.equityReviewRecordVo = res.data.equityReviewRecordVo
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>
